import * as fromRouter from '../reducers/router.reducer';
import { RouterActions } from '../actions/router.action'; // Import RouterActions

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ActionReducerMap } from '@ngrx/store';
import { InjectionToken } from '@angular/core';

export interface RouterState {
  router: fromRouter.RouterState;
}

export const ROUTER_REDUCER_TOKEN = new InjectionToken<
  ActionReducerMap<RouterState, RouterActions>
>('Router Reducers'); // Update InjectionToken with RouterActions

export function getRouterReducer(): ActionReducerMap<RouterState, RouterActions> | any {
  // Update ActionReducerMap type
  // map of reducers
  return {
    router: fromRouter.RouterReducer,
  };
}

const getRouterState = createFeatureSelector<RouterState>('router-manager');

export const confirmRouterAction = createSelector(getRouterState, (state) => state.router.end);

export const getRouterEnd = createSelector(getRouterState, (state) => state.router.end);
